(function () {
  'use strict';

  if (window.__CL_FF_INTENT_V1__) return;
  window.__CL_FF_INTENT_V1__ = true;

  var ENDPOINT = 'https://hook.us2.make.com/b9ywustuhqmd89dp8pn324imhv62i9if';
  var COLLECTION_HANDLE = 'fan-favorites';
  var COLLECTION_ID = 'gid://shopify/Collection/655931965726';
  var COLLECTION_NAME = 'Fan Favorites';
  var SESSION_KEY = 'cl_ff_intent_session_v1';
  var SENT_KEY = 'cl_ff_intent_sent_v1';
  var COLLECTION_DWELL_MS = 30000;
  var PRODUCT_DWELL_MS = 20000;

  function text(value) {
    return value === undefined || value === null ? '' : String(value).trim();
  }

  function attr(node, name) {
    return node && node.getAttribute ? text(node.getAttribute(name)) : '';
  }

  function absoluteUrl(value) {
    var raw = text(value);
    if (!raw) return '';
    try {
      return new URL(raw, window.location.origin).toString();
    } catch (e) {
      return raw;
    }
  }

  function cleanUrl(value) {
    var raw = absoluteUrl(value);
    if (!raw) return '';
    try {
      var url = new URL(raw);
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (e) {
      return raw.split('?')[0].split('#')[0];
    }
  }

  function randomId(prefix) {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return prefix + '_' + window.crypto.randomUUID();
      }
    } catch (e) {}
    return prefix + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
  }

  function storageGet(key, fallback) {
    try {
      var value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  var sessionId = storageGet(SESSION_KEY, null);
  if (!sessionId) {
    sessionId = randomId('sess');
    storageSet(SESSION_KEY, sessionId);
  }

  var landingPage = '';
  try {
    landingPage = window.sessionStorage.getItem('cl_ff_landing_page_v1') || '';
    if (!landingPage) {
      landingPage = window.location.href;
      window.sessionStorage.setItem('cl_ff_landing_page_v1', landingPage);
    }
  } catch (e) {
    landingPage = window.location.href;
  }

  function emailFromForm(form) {
    if (!form || !form.querySelector) return '';
    var input = form.querySelector('input[type="email"], input[name="email"], input[name="$email"]');
    return input ? text(input.value).toLowerCase() : '';
  }

  function phoneFromForm(form) {
    if (!form || !form.querySelector) return '';
    var input = form.querySelector('input[type="tel"], input[name="phone"], input[name="$phone_number"]');
    return input ? text(input.value) : '';
  }

  function queuedIdentify() {
    var queue = window._learnq;
    if (!queue || !queue.length) return { email: '', phone: '' };
    for (var i = queue.length - 1; i >= 0; i -= 1) {
      var item = queue[i];
      if (!item || item[0] !== 'identify' || !item[1]) continue;
      return {
        email: text(item[1].$email || item[1].email).toLowerCase(),
        phone: text(item[1].$phone_number || item[1].phone_number)
      };
    }
    return { email: '', phone: '' };
  }

  function profileIdentity(form) {
    var queued = queuedIdentify();
    var email = emailFromForm(form) || text(window.__CL_PROFILE_EMAIL__).toLowerCase() || queued.email;
    var phone = phoneFromForm(form) || text(window.__CL_PROFILE_PHONE__) || queued.phone;
    return { email: email, phone: phone };
  }

  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return false;
    try {
      var analytics = typeof privacy.analyticsProcessingAllowed === 'function'
        ? privacy.analyticsProcessingAllowed() === true
        : true;
      return analytics && privacy.marketingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  function currentUtm() {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var output = {};
    var stored = {};
    try {
      stored = JSON.parse(window.sessionStorage.getItem('cl_web_signal_attribution_v2') || '{}');
      stored = stored.last || stored.first || stored || {};
    } catch (e) {}
    var params = new URLSearchParams(window.location.search);
    keys.forEach(function (key) {
      var value = text(params.get(key)) || text(stored[key]);
      output[key] = value || null;
    });
    return output;
  }

  function canonicalUrl() {
    var link = document.querySelector('link[rel="canonical"]');
    return cleanUrl(link ? link.getAttribute('href') : window.location.href);
  }

  function metaDescription() {
    var meta = document.querySelector('meta[name="description"]');
    return meta ? text(meta.getAttribute('content')) : '';
  }

  function closest(node, selector) {
    var current = node;
    while (current && current !== document) {
      if (current.matches && current.matches(selector)) return current;
      current = current.parentNode;
    }
    return null;
  }

  function productData(node) {
    if (!node) return {
      id: null,
      legacy_id: null,
      handle: null,
      title: null,
      variant_id: null,
      sku: null,
      type: null,
      url: null,
      image_url: null,
      price: null,
      availability: null
    };
    var price = attr(node, 'data-cl-product-price');
    var available = attr(node, 'data-cl-product-availability');
    return {
      id: attr(node, 'data-cl-product-id') || null,
      legacy_id: attr(node, 'data-cl-product-legacy-id') || null,
      handle: attr(node, 'data-cl-product-handle') || null,
      title: attr(node, 'data-cl-product-title') || null,
      variant_id: attr(node, 'data-cl-product-variant-id') || null,
      sku: attr(node, 'data-cl-product-sku') || null,
      type: attr(node, 'data-cl-product-type') || null,
      url: cleanUrl(attr(node, 'data-cl-product-url')) || null,
      image_url: absoluteUrl(attr(node, 'data-cl-product-image-url')) || null,
      price: price === '' || isNaN(Number(price)) ? null : Number(price),
      availability: available === '' ? null : available === 'true'
    };
  }

  function collectionData(node) {
    var source = node || document.querySelector('[data-cl-ff-collection="true"]') || document.body;
    return {
      name: attr(source, 'data-cl-collection-name') || COLLECTION_NAME,
      title: attr(source, 'data-cl-collection-title') || COLLECTION_NAME,
      handle: attr(source, 'data-cl-collection-handle') || attr(source, 'data-cl-collection') || COLLECTION_HANDLE,
      id: attr(source, 'data-cl-collection-id') || COLLECTION_ID
    };
  }

  var productRoot = document.querySelector('[data-cl-ff-product="true"]');
  var collectionRoot = document.querySelector('[data-cl-ff-collection="true"]');
  var isProductPage = Boolean(productRoot);
  var isCollectionPage = Boolean(collectionRoot);
  if (!isProductPage && !isCollectionPage) return;

  function productNodeForTarget(target) {
    return closest(target, '[data-cl-ff-product="true"]');
  }

  function sentMap() {
    return storageGet(SENT_KEY, {});
  }

  function sentKey(intentType, product) {
    return intentType + '|' + (product && product.id ? product.id : 'collection');
  }

  function eventContext(intentType, product, collection, now) {
    var pageType = isProductPage ? 'product' : 'collection';
    var pageUrl = window.location.href;
    var pageHandle = text(window.__CL_PAGE_HANDLE__) || window.location.pathname;
    return {
      campaign: 'pod_fan_favorites',
      intent_type: intentType,
      collection_name: collection.name,
      collection_title: collection.title,
      collection_handle: collection.handle,
      collection_id: collection.id,
      pod_collection: true,
      product_id: product.id,
      product_legacy_id: product.legacy_id,
      product_handle: product.handle,
      product_title: product.title,
      variant_id: product.variant_id,
      product_variant_id: product.variant_id,
      sku: product.sku,
      product_type: product.type,
      product_url: product.url,
      product_image_url: product.image_url,
      product_price: product.price,
      product_availability: product.availability,
      page_handle: pageHandle,
      page_url: pageUrl,
      page_type: pageType,
      page_title: text(document.title),
      canonical_url: canonicalUrl(),
      seo_title: text(document.title),
      seo_description: metaDescription(),
      referrer: text(document.referrer),
      landing_page: landingPage,
      session_id: sessionId,
      timestamp: now,
      placement: isProductPage ? 'fan_favorites_product_page' : 'fan_favorites_collection_page',
      source: 'chris-lake.com'
    };
  }

  function emit(intentType, target, options, form) {
    options = options || {};
    var product = productData(target);
    var collection = collectionData(target);
    var identity = profileIdentity(form);
    if ((!identity.email && !identity.phone) || !marketingAllowed()) return false;

    var key = sentKey(intentType, product);
    var existing = sentMap();
    if (existing[key]) return false;

    var now = new Date().toISOString();
    var activeSeconds = Math.max(0, Math.floor((options.activeMs || 0) / 1000));
    var eventId = randomId('evt');
    var ctx = eventContext(intentType, product, collection, now);
    var utm = currentUtm();
    var event = {
      intent_type: intentType,
      collection_name: collection.name,
      collection_title: collection.title,
      collection_handle: collection.handle,
      collection_id: collection.id,
      pod_collection: true,
      product_id: product.id,
      product_legacy_id: product.legacy_id,
      product_handle: product.handle,
      product_title: product.title,
      variant_id: product.variant_id,
      product_variant_id: product.variant_id,
      sku: product.sku,
      product_type: product.type,
      product_url: product.url,
      product_image_url: product.image_url,
      product_price: product.price,
      product_availability: product.availability,
      dwell_seconds: activeSeconds,
      active_dwell: Boolean(options.activeDwell),
      active_time_seconds: activeSeconds,
      session_id: sessionId,
      event_id: eventId,
      referrer: text(document.referrer) || null,
      landing_page: landingPage || null,
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      utm_content: utm.utm_content,
      utm_term: utm.utm_term,
      timestamp: now,
      destination: product.url || cleanUrl(window.location.href) || null,
      url: product.url || cleanUrl(window.location.href) || null,
      link_text: product.title || collection.name,
      click_target: options.clickTarget || null
    };

    var payload = {
      schema_version: 'cl2026.v2',
      build: 'cl-pod-fan-favorites-intent-20260917-v1',
      event_id: eventId,
      event_type: 'CL_POD_Fan_Favorites_Intent',
      occurred_at: now,
      profile: {
        email: identity.email || null,
        phone_number: identity.phone || null
      },
      context: ctx,
      event: event,
      utm: utm,
      consent: {
        email: Boolean(identity.email),
        sms: Boolean(window.__CL_SMS_CONSENT__ === true || window.__CL_PROFILE_SMS_CONSENT__ === true),
        source: 'shopify_customer_privacy'
      }
    };

    existing[key] = now;
    storageSet(SENT_KEY, existing);

    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(
        ENDPOINT,
        new Blob([body], { type: 'application/json' })
      )) return true;
    } catch (e) {}
    try {
      if (window.fetch) {
        window.fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true,
          credentials: 'omit'
        }).catch(function () {});
      }
    } catch (e) {}
    return true;
  }

  var activeMs = 0;
  var visibleSince = document.visibilityState === 'visible' ? Date.now() : 0;
  var pageViewSent = false;
  var clickSourceSent = false;
  var dwellSent = false;

  function accumulatedActiveMs() {
    return activeMs + (visibleSince ? Date.now() - visibleSince : 0);
  }

  function pauseActiveClock() {
    if (visibleSince) {
      activeMs += Date.now() - visibleSince;
      visibleSince = 0;
    }
  }

  function resumeActiveClock() {
    if (!visibleSince && document.visibilityState === 'visible') {
      visibleSince = Date.now();
    }
  }

  function maybePageView(form) {
    if (pageViewSent) return;
    var type = isProductPage ? 'product_view' : 'collection_view';
    if (emit(type, isProductPage ? productRoot : collectionRoot, {
      activeMs: 0,
      activeDwell: false,
      clickTarget: 'page_view'
    }, form)) {
      pageViewSent = true;
    }
    var medium = currentUtm().utm_medium;
    if (!clickSourceSent && (medium === 'email' || medium === 'sms')) {
      if (emit(medium === 'email' ? 'email_click' : 'sms_click',
        isProductPage ? productRoot : collectionRoot,
        { activeMs: 0, activeDwell: false, clickTarget: medium + '_return_visit' },
        form)) {
        clickSourceSent = true;
      }
    }
  }

  function maybeDwell(form) {
    if (dwellSent) return;
    var threshold = isProductPage ? PRODUCT_DWELL_MS : COLLECTION_DWELL_MS;
    if (accumulatedActiveMs() < threshold) return;
    if (emit('qualified_dwell', isProductPage ? productRoot : collectionRoot, {
      activeMs: accumulatedActiveMs(),
      activeDwell: true,
      clickTarget: isProductPage ? 'active_20_second_product_dwell' : 'active_30_second_collection_dwell'
    }, form)) {
      dwellSent = true;
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      pauseActiveClock();
      maybeDwell(null);
    } else {
      resumeActiveClock();
      maybePageView(null);
    }
  });

  document.addEventListener('click', function (event) {
    var product = productNodeForTarget(event.target);
    if (!product) return;
    var link = closest(event.target, 'a[href]');
    if (!link) return;
    emit('product_click', product, {
      activeMs: accumulatedActiveMs(),
      activeDwell: false,
      clickTarget: 'fan_favorites_collection_card'
    }, null);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    window.setTimeout(function () {
      maybePageView(form);
      maybeDwell(form);
    }, 250);
  }, true);

  window.addEventListener('klaviyoForms', function () {
    maybePageView(null);
    maybeDwell(null);
  });

  window.addEventListener('pagehide', function () {
    pauseActiveClock();
    maybeDwell(null);
  });

  maybePageView(null);
  window.setInterval(function () {
    maybePageView(null);
    maybeDwell(null);
  }, 1000);
})();